/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 3748:
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function debounce(fn, wait) {
  var _this = this;
  var t;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(t);
    t = setTimeout(function () {
      return fn.apply(_this, args);
    }, wait);
  };
}
if (!customElements.get('full-menu')) {
  var FullMenu = /*#__PURE__*/function (_HTMLElement) {
    _inherits(FullMenu, _HTMLElement);
    var _super = _createSuper(FullMenu);
    function FullMenu() {
      _classCallCheck(this, FullMenu);
      return _super.apply(this, arguments);
    }
    _createClass(FullMenu, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.submenus = this.querySelectorAll(
        // eslint-disable-next-line max-len
        '.header-full-menu__menu--has-children:not(.header-full-menu__menu--has-megamenu) > .header-full-menu__sub-menu');
        if (!this.submenus.length) {
          return;
        }
        var that = this;
        // resize on initial load

        window.addEventListener('resize', debounce(function () {
          that.resizeSubMenus();
        }, 100));
        window.dispatchEvent(new Event('resize'));
        document.fonts.ready.then(function () {
          that.resizeSubMenus();
        });
      }
    }, {
      key: "resizeSubMenus",
      value: function resizeSubMenus() {
        this.submenus.forEach(function (submenu) {
          var subMenus = submenu.querySelectorAll(
          // eslint-disable-next-line max-len
          ':scope > .header-full-menu__menu--has-children > .header-full-menu__sub-menu');
          subMenus.forEach(function (subMenu) {
            var w = subMenu.offsetWidth;
            var l = subMenu.parentElement.parentElement.getBoundingClientRect().left + subMenu.parentElement.parentElement.clientWidth + 10;
            var total = w + l;
            if (total > document.body.clientWidth) {
              subMenu.parentElement.classList.add('left-submenu');
            } else if (subMenu.parentElement.classList.contains('left-submenu')) {
              subMenu.parentElement.classList.remove('left-submenu');
            }
          });
        });
      }
    }]);
    return FullMenu;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
  customElements.define('full-menu', FullMenu);
}

/***/ }),

/***/ 5324:
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (!customElements.get('header-search')) {
  var HeaderSearch = /*#__PURE__*/function (_HTMLElement) {
    _inherits(HeaderSearch, _HTMLElement);
    var _super = _createSuper(HeaderSearch);
    function HeaderSearch() {
      var _this;
      _classCallCheck(this, HeaderSearch);
      _this = _super.call(this);
      _this.detailsContainer = _this.querySelector('details');
      _this.toggle = _this.querySelector('[data-header-saerch="open"]');
      _this.drawer = _this.querySelector('[data-header-search="drawer"]');
      _this.closeButton = _this.querySelector('[data-header-search="close"]');
      _this.detailsContainer.addEventListener('keyup', function (event) {
        return event.code.toUpperCase() === 'ESCAPE' && _this.close();
      });
      _this.toggle.addEventListener('click', _this.onSummaryClick.bind(_assertThisInitialized(_this)));
      _this.closeButton.addEventListener('click', _this.close.bind(_assertThisInitialized(_this)));
      _this.toggle.setAttribute('role', 'button');
      document.querySelectorAll("[data-header-search='open']").forEach(function (link) {
        if (link !== _this.toggle) {
          link.addEventListener('click', function (event) {
            event.preventDefault();
            _this.open();
          });
        }
      });
      return _this;
    }
    _createClass(HeaderSearch, [{
      key: "onSummaryClick",
      value: function onSummaryClick(event) {
        event.preventDefault();
        if (this.detailsContainer.hasAttribute('open')) {
          this.close();
        } else {
          this.open();
        }
      }
    }, {
      key: "onBodyClick",
      value: function onBodyClick(event) {
        if (!this.contains(event.target) && !event.target.closest('[data-header-search="open"]') || event.target.getAttribute('data-header-search') === 'overlay') {
          this.close();
        }
      }
    }, {
      key: "open",
      value: function open() {
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        this.detailsContainer.setAttribute('open', true);
        document.body.addEventListener('click', this.onBodyClickEvent);
        document.body.classList.add('overflow-hidden');

        // TODO: Move into a separate abstraction
        setTimeout(function () {
          document.querySelector('input[type="search"]').focus();
        }, 300);
      }
    }, {
      key: "close",
      value: function close() {
        var _this2 = this;
        var animationStart;
        this.drawer.classList.add('closing');
        var handleAnimation = function handleAnimation(time) {
          if (animationStart === undefined) {
            animationStart = time;
          }
          var elapsedTime = time - animationStart;
          if (elapsedTime < 400) {
            window.requestAnimationFrame(handleAnimation);
          } else {
            _this2.drawer.classList.remove('closing');
            _this2.detailsContainer.removeAttribute('open');
            document.body.classList.remove('overflow-hidden');
          }
        };
        window.requestAnimationFrame(handleAnimation);
      }
    }]);
    return HeaderSearch;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
  customElements.define('header-search', HeaderSearch);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/* harmony import */ var _snippets_header_full_menu_header_full_menu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3748);
/* harmony import */ var _snippets_header_full_menu_header_full_menu__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_snippets_header_full_menu_header_full_menu__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _snippets_header_search_header_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5324);
/* harmony import */ var _snippets_header_search_header_search__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_snippets_header_search_header_search__WEBPACK_IMPORTED_MODULE_1__);


var setAnnouncementHeight = function setAnnouncementHeight(component) {
  var h = component.clientHeight;
  document.documentElement.style.setProperty('--announcement-height', "".concat(h, "px"));
};
var setHeaderOffset = function setHeaderOffset(header) {
  var h = header.getBoundingClientRect().top;
  if (h < 0) {
    document.documentElement.style.setProperty('--header-offset', '0px');
  } else {
    document.documentElement.style.setProperty('--header-offset', "".concat(h, "px"));
  }
};
var setHeaderHeight = function setHeaderHeight(header) {
  var h = header.clientHeight;
  document.documentElement.style.setProperty('--header-height', "".concat(h, "px"));
};
var lastScrollY = window.scrollY;
var isScrollDown = function isScrollDown() {
  var currentScrollY = window.scrollY;
  var result = currentScrollY > lastScrollY;
  lastScrollY = currentScrollY;
  return result;
};
var onSummaryClick = function onSummaryClick(event) {
  var summaryElement = event.currentTarget;
  var detailsElement = summaryElement.parentNode;
  var parentMenuElement = detailsElement.closest('.mobile-menu__links');
  setTimeout(function () {
    detailsElement.classList.add('menu-opening');
    if (parentMenuElement) {
      parentMenuElement.classList.add('submenu-open');
    }
  }, 100);
};
var closeAnimation = function closeAnimation(detailsElement) {
  var animationStart;
  var handleAnimation = function handleAnimation(time) {
    if (animationStart === undefined) {
      animationStart = time;
    }
    var elapsedTime = time - animationStart;
    if (elapsedTime < 400) {
      window.requestAnimationFrame(handleAnimation);
    } else {
      detailsElement.removeAttribute('open');
      detailsElement.querySelectorAll('details').forEach(function (details) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        details.classList.remove('submenu-open');
      });
    }
  };
  window.requestAnimationFrame(handleAnimation);
};
var onCloseButtonClick = function onCloseButtonClick(event) {
  event.preventDefault();
  var detailsElement = event.currentTarget.closest('details');
  detailsElement.classList.remove('menu-opening');
  closeAnimation(detailsElement);
};
var initHeader = function initHeader() {
  var headerSection = document.querySelector('.header-section');
  var header = document.getElementById('header');
  var menu = document.getElementById('mobile-menu');
  var toggle = document.querySelector('.mobile-menu');
  var announcementBar = document.querySelector('[data-section="announcement-bar"]');
  if (!header || !headerSection) {
    return;
  }
  document.addEventListener('keyup', function (e) {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        toggle.removeAttribute('open');
        toggle.classList.remove('active');
      }
    }
  });
  toggle.querySelectorAll('[data-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      setAnnouncementHeight(headerSection);
      if (toggle.classList.contains('active')) {
        e.preventDefault();
        document.body.classList.remove('overflow-hidden');
        toggle.classList.remove('active');
        closeAnimation(toggle);
      } else {
        document.body.classList.add('overflow-hidden');
        setTimeout(function () {
          toggle.classList.add('active');
        });
      }
      window.dispatchEvent(new Event('resize.resize-select'));
    });
  });
  var headerScrollThreshold = Number(header.getAttribute('data-header-scroll-threshold')) || 0;
  var headerSectionStyles = window.getComputedStyle(headerSection);
  var setHeaderAttrs = function setHeaderAttrs() {
    var isFixedHeader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var isHiddenHeader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    header.setAttribute('data-fixed-header', "".concat(isFixedHeader));
    header.setAttribute('data-hidden-header', "".concat(isHiddenHeader));
  };
  var initFixedHeader = function initFixedHeader() {
    if (headerSectionStyles.position === 'sticky') {
      setHeaderAttrs();
      return;
    }
    var announcementBarHeight = (announcementBar === null || announcementBar === void 0 ? void 0 : announcementBar.clientHeight) || 0;
    var headerBottom = announcementBarHeight + headerSection.clientHeight;
    var scrollDown = isScrollDown();
    var isFixedHeader = window.scrollY >= announcementBarHeight;
    var isHiddenHeader = isFixedHeader && window.scrollY > headerBottom + headerScrollThreshold && scrollDown;
    setHeaderAttrs(isFixedHeader, isHiddenHeader);
  };
  window.addEventListener('scroll', function () {
    setHeaderOffset(headerSection);
    setHeaderHeight(header);
    initFixedHeader();
  }, {
    passive: true
  });
  window.dispatchEvent(new Event('scroll'));
  window.addEventListener('resize', function () {
    setHeaderOffset(headerSection);
    setHeaderHeight(header);
    if (announcementBar) {
      setAnnouncementHeight(announcementBar);
    }
  }, {
    passive: true
  });
  menu.querySelectorAll('summary').forEach(function (summary) {
    return summary.addEventListener('click', onSummaryClick);
  });
  menu.querySelectorAll('button').forEach(function (button) {
    return button.addEventListener('click', onCloseButtonClick);
  });
  
  function setCurrency() {
    var currentUrl = window.location.href;
    var isFrenchSite = currentUrl.includes('/fr-eu');
    
    if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
      if (isFrenchSite && Shopify.currency.active !== 'EUR') {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            currency: 'EUR'
          })
        }).then(function(response) { return response.json(); })
          .then(function(data) {
            if (data.currency === 'EUR') {
              //window.location.reload();
            }
          });
      } else if (!isFrenchSite && Shopify.currency.active !== 'USD') {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            currency: 'USD'
          })
        }).then(function(response) { return response.json(); })
          .then(function(data) {
            if (data.currency === 'USD') {
              //window.location.reload();
            }
          });
      }
    }
  }
  
  setCurrency();
};
window.Sections = window.Sections || {};
if (window.Sections.header) {
  window.Sections.header += 1;
} else {
  window.Sections.header = 1;
  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
  });
}
})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

/******/ })()
;